export class OptionsValidator {
    constructor(gformSejour) {
        this.gform = gformSejour;
        this.wrapper = gformSejour.formWrapper;
        this.init();
    }

    init() {
        this.bindValidation();
    }

    bindValidation() {
        this.wrapper.addEventListener('change', (e) => {
            const field = e.target.closest('.gfield');
            // Si c'est un champ adultes ou enfants, valider les pensions
            if (field?.classList.contains('gf-sejour-adults') || field?.classList.contains('gf-sejour-children')) {
                this.validatePensionLimits();
            }
            // Si c'est un champ pension, valider aussi
            if (field?.classList.contains('gf-sejour-pension-adult') || field?.classList.contains('gf-sejour-pension-child')) {
                this.validatePensionLimits();
            }
        });

        this.wrapper.addEventListener('input', (e) => {
            const field = e.target.closest('.gfield');
            if (field?.classList.contains('gf-sejour-pension-adult') || field?.classList.contains('gf-sejour-pension-child')) {
                this.validatePensionLimits();
            }
        });
    }

    validatePensionLimits() {
        const { adults, children } = this.gform.state;

        const adultPensionField = this.wrapper.querySelector('.gf-sejour-pension-adult');
        const childPensionField = this.wrapper.querySelector('.gf-sejour-pension-child');
        const adultInput = adultPensionField?.querySelector('.ginput_quantity');
        const childInput = childPensionField?.querySelector('.ginput_quantity');

        // Pension adulte : limité au nombre d'adultes
        if (adultInput) {
            const adultValue = parseInt(adultInput.value) || 0;
            if (adultValue > adults) {
                adultInput.value = adults;
                this.triggerChange(adultInput);
            }
            this.updateMaxAttribute(adultInput, adults);
        }

        // Pension enfant : limité au nombre d'enfants
        if (childInput) {
            const childValue = parseInt(childInput.value) || 0;
            if (childValue > children) {
                childInput.value = children;
                this.triggerChange(childInput);
            }
            this.updateMaxAttribute(childInput, children);
        }

        this.hideWarning();
        this.updateQuantityButtonStates();
    }

    updateMaxAttribute(input, max) {
        input.setAttribute('max', max);

        const plusBtn = input.closest('.gf-quantity-control')?.querySelector('.gf-quantity-btn--plus');
        if (plusBtn) {
            const currentValue = parseInt(input.value) || 0;
            plusBtn.disabled = currentValue >= max;
        }
    }

    updateQuantityButtonStates() {
        const { adults, children } = this.gform.state;
        
        // Mettre à jour les boutons de pension adulte
        const adultPensionField = this.wrapper.querySelector('.gf-sejour-pension-adult');
        if (adultPensionField) {
            const control = adultPensionField.querySelector('.gf-quantity-control');
            if (control) {
                const input = control.querySelector('input');
                const plusBtn = control.querySelector('.gf-quantity-btn--plus');
                const minusBtn = control.querySelector('.gf-quantity-btn--minus');
                if (input && plusBtn && minusBtn) {
                    const value = parseInt(input.value) || 0;
                    plusBtn.disabled = value >= adults;
                    minusBtn.disabled = value <= 0;
                }
            }
        }

        // Mettre à jour les boutons de pension enfant
        const childPensionField = this.wrapper.querySelector('.gf-sejour-pension-child');
        if (childPensionField) {
            const control = childPensionField.querySelector('.gf-quantity-control');
            if (control) {
                const input = control.querySelector('input');
                const plusBtn = control.querySelector('.gf-quantity-btn--plus');
                const minusBtn = control.querySelector('.gf-quantity-btn--minus');
                if (input && plusBtn && minusBtn) {
                    const value = parseInt(input.value) || 0;
                    plusBtn.disabled = value >= children;
                    minusBtn.disabled = value <= 0;
                }
            }
        }

        // Mettre à jour les boutons de transfert
        const transferField = this.wrapper.querySelector('.gf-sejour-transfer');
        if (transferField) {
            const control = transferField.querySelector('.gf-quantity-control');
            if (control) {
                const input = control.querySelector('input');
                const plusBtn = control.querySelector('.gf-quantity-btn--plus');
                const minusBtn = control.querySelector('.gf-quantity-btn--minus');
                if (input && plusBtn && minusBtn) {
                    const value = parseInt(input.value) || 0;
                    const totalParticipants = adults + children;
                    plusBtn.disabled = value >= totalParticipants;
                    minusBtn.disabled = value <= 0;
                }
            }
        }
    }

    showWarning(message) {
        let warning = this.wrapper.querySelector('.gf-pension-warning');
        if (!warning) {
            warning = document.createElement('div');
            warning.className = 'gf-pension-warning';
            warning.style.cssText = `
                background: rgba(254, 72, 109, 0.1);
                color: var(--color-danger);
                padding: 0.75rem 1rem;
                border-radius: var(--radius-medium);
                font-size: 0.875rem;
                margin-top: 0.5rem;
            `;

            const pensionSection = this.wrapper.querySelector('#field_' + this.gform.formId + '_31');
            if (pensionSection) {
                pensionSection.appendChild(warning);
            }
        }
        warning.textContent = message;
    }

    hideWarning() {
        const warning = this.wrapper.querySelector('.gf-pension-warning');
        if (warning) {
            warning.remove();
        }
    }

    triggerChange(input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }
}
